/*
  This file was copied from the autosuggest-highlight npm package.
  https://www.npmjs.com/package/autosuggest-highlight ,MIT license.
  Converted to TS and made a few fixes and changes...
*/

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
const specialCharsRegex = /[.*+?^${}()|[\]\\]/g;

const whitespacesRegex = /\s+/;

const escapeRegexCharacters = (str: string) => {
    return str.replace(specialCharsRegex, '\\$&');
};

const match = (text: string, query: string) => {
    return (
        query
            .trim()
            .split(whitespacesRegex)
            // If query is blank, we'll get empty string here, so let's filter it out.
            .filter(function (word) {
                return word.length > 0;
            })
            .reduce(function (result: any, word) {
                const wordLen = word.length;
                const regex = new RegExp(escapeRegexCharacters(word), 'ig');
                const index = text.search(regex);

                if (index > -1) {
                    result.push([index, index + wordLen]);

                    // Replace what we just found with spaces so we don't find it again.
                    text = text.slice(0, index) + new Array(wordLen + 1).join(' ') + text.slice(index + wordLen);
                }

                return result;
            }, [])
            .sort(function (match1: any, match2: any) {
                return match1[0] - match2[0];
            })
    );
};

export { match };
